import React, { useEffect, useState } from 'react'
import DataTable from '../../../component/data_table/DataTable'
import AddButton from '../../../component/buttons/AddButton';
import { Link, useNavigate } from 'react-router-dom';
import { FilePenLine, Trash2 } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { purposeListTodo } from '../../../redux/slices/master/purpose/PurposeList';
import Loader from '../../../component/loader/Loader';
import { deletePurposeTodo } from '../../../redux/slices/master/purpose/DeletePurpose';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { Tooltip } from 'react-tooltip';

export default function PurposeList() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(false)
    const purposeList = useSelector(state => state?.purposeList?.data?.data)

    useEffect(() => {
        setLoading(true)
        dispatch(purposeListTodo({ navigate })).then((res) => list_res(res?.payload))
    }, [bool])

    const list_res = (res) => {
        if (res?.status == 200) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const editItem = (data) => {
        navigate('/update-purpose', { state: data })
    }

    const deleteItem = (data) => {
        Swal.fire({
            title: "Purpose Delete",
            text: 'Are you sure want to delete',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Confirm'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deletePurposeTodo(data)).then((res) => del_res(res))
            }
        })
    }

    const del_res = (res) => {
        if (res?.payload?.status == 204) {
            setBool(!bool)
            Swal.fire({
                title: 'Purpose',
                text: res?.data?.massage,
                icon: 'success',
                confirmButtonText: 'OK'
            })

        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        } else if (res?.payload?.status == 404) {
            toast.error('Not Found', { position: "bottom-right" });
        } else {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }

    const columnDefs = [
        {
            headerName: 'S.NO',
            maxWidth: 90,
            valueGetter: 'node.rowIndex + 1',
            filter: false,
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
        },
        {
            headerName: 'PURPOSE',
            field: 'name',
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },
        {
            headerName: 'TYPE',
            field: 'type',
            valueFormatter: params => params?.value ? params.value.charAt(0).toUpperCase() + params.value.slice(1) : '',
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },

        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params =>
                params?.data?.status === 'Active'
                    ? <span className='badge text-bg-success'>Active</span>
                    : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
        },
        {
            headerName: 'ACTION',
            cellRenderer: params => (
                <div className='d-flex'>
                    <span
                        data-tooltip-id='edit'
                        data-tooltip-content="Purpose Update"
                        data-tooltip-place="bottom"
                        onClick={() => editItem(params?.data)}
                    >
                        <FilePenLine className='text-success' size={20} />
                    </span>
                    {/* <span className='ms-2'
                        data-tooltip-id='delete'
                        data-tooltip-content="Purpose Delete"
                        data-tooltip-place="bottom"
                        onClick={() => deleteItem(params?.data?._id)}
                    >
                        <Trash2 className='text-danger' size={20} />
                    </span> */}
                    <Tooltip id='edit' className='bg-success tooltip_msg' />
                    <Tooltip id='delete' className='bg-danger tooltip_msg' />
                </div>
            ),
            autoHeight: true,
        }
    ];

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout_head d-flex justify-content-between align-items-center mb-3'>
                            <h5>Purpose List</h5>
                            <Link to='/add-purpose'>   <AddButton label={"Add PURPOSE"} /> </Link>
                        </div>
                        {loading ?
                            <div className='text-center'>
                                <Loader />
                            </div>
                            :
                            <DataTable
                                rowData={purposeList}
                                columnDefs={columnDefs}
                                height={'65vh'}
                            />}
                    </div>
                </div>
            </div>
        </>
    )
}


